import {
  LinnworksInstallAttemptStatus,
  LinnworksLocality,
} from "@redotech/redo-integrations-definitions-common/linnworks/linnworks";
import * as z from "zod";

export const getLinnworksIntegrationStatus = {
  name: "getLinnworksIntegrationStatus" as const,
  input: z.object({ installAttemptNonce: z.string().uuid().optional() }),
  output: z.object({
    isConnected: z.boolean(),
    omsEnabled: z.boolean().optional(),
    returnsEnabled: z.boolean().optional(),
    accountEmail: z.string().optional(),
    accountUserName: z.string().optional(),
    installAttemptStatus: z.enum(LinnworksInstallAttemptStatus).optional(),
    locality: z.enum(LinnworksLocality).optional(),
  }),
};
